<style lang="less" scoped>
.QuestionGr{display: flex;flex-direction: column;}
.table {border-collapse: collapse;width: 100%;margin-top: 10px;}
table {border-collapse: collapse;width: 100%;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr {width: 100%;height: 50px;}
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;}
.btnbox .elbtn {margin-top: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr td .el-form-item /deep/.el-form-item__content {margin-right: 10px;}
.type /deep/ .el-input__inner {width: 150px;}
.content /deep/ .el-input__inner {width: 150px;}
.date-picker.el-input {width: 150px;}
.date-picker.el-input {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.fujian:hover{cursor: pointer;color:rgb(45, 137, 241);}
.pagination{margin-bottom: 40px;margin-top: 40px;}
</style>

<template>
  <div class="QuestionGr" id="QuestionGr">
    <!-- 搜素条件 -->
    <el-form ref="form" :model="form">
      <table>
        <tr class="tr">
          <td>
            <el-form-item>
              <div class="td">
                <el-input v-model="form.content" placeholder="请输入关键词" class="input content"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="td">
                <el-date-picker v-model="form.starttime" type="datetime" placeholder="选择开始时间" class="date-picker"></el-date-picker>
                <span style="display: inline-block;width: 32px;text-align: center;">至</span>
                <el-date-picker v-model="form.endtime" type="datetime" placeholder="选择结束时间" class="date-picker"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="td td1">
                <el-select clearable v-model="form.iscomments" placeholder="请选择状态" class="type">
                  <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.key"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="td">
                <el-button class="elbtn search" @click="search">搜索</el-button>
                <el-button class="elbtn reset" @click="cancelfnBtn()">重置</el-button>
              </div>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <!-- 数据列表 -->
    <div class="el-tablebox">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%; font-size: 15px;"
        @selection-change="handleSelectionChange"
        stripe
        border
        :cell-style="{textAlign: 'center', padding: '0'}"
        :header-cell-style="{background: '#F5F5F5', color: '#606266', textAlign: 'center',}">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="type" label="类型" width="90">
          <template slot-scope="scope">{{ scope.row.type | getClassification() }}</template>
        </el-table-column>
        <el-table-column prop="user" label="咨询用户" width="120"></el-table-column>
        <el-table-column prop="content" label="咨询内容" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="相关图片" width="90">
          <template slot-scope="scope">
            <p class="fujian" @click="look(scope.row.thumb)">查看附件</p>
            <el-dialog :visible.sync="isdialogVisible" width="30%" title="相关图片" class="mydialog">
              <img :src="urlShow" width="320px" height="280px" class="head_pic"/>
            </el-dialog>
          </template>
        </el-table-column>
        <el-table-column label="提问时间" width="180">
          <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
        </el-table-column>
        <el-table-column label="咨询状态" width="90">
          <template slot-scope="scope">{{ (scope.row.iscomments) | getComments() }}</template>
        </el-table-column>
        <el-table-column prop="id" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="lookrelease(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- Page页 -->
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
    <!-- 提问弹框 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="dialogVisible"
      :width="widthCSH"
      title="法律服务-咨询"
      class="mydialog">
      <LegalQuestions @cancle="cancle" v-if="dialogVisible"></LegalQuestions>
    </el-dialog>
    <!-- 查看弹框 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="dialogLookVisible"
      :width="widthCSH"
      title="法律服务-查看"
      class="mydialog">
      <Lookrelease :rowid='rowid' @cancle="cancle" v-if="dialogLookVisible"></Lookrelease>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 安进
 * 其他用户提问列表页面
 */
import filters from '../../../method/filter'
import LegalQuestions from './LegalQuestions.vue'
import Lookrelease from '../Lookrelease.vue'
export default {
  mixins: [filters],
  components: {
    LegalQuestions,
    Lookrelease
  },
  data()
  {
    return {
      // 查询条件表单
      form: {
        type: 2,
        content: '',
        starttime: '',
        endtime: '',
        iscomments: null,
        count: 20
      },
      // 类型下拉数据
      options1: [
        { value: '选项1', label: '咨询服务', key: 1 },
        { value: '选项2', label: '法律服务', key: 2 }
      ],
      // 类型下拉数据
      options2: [
        { value: '选项1', label: '未回复', key: 2 },
        { value: '选项2', label: '已回复', key: 1 }
      ],
      // 列表数据
      tableData: [],
      // 图片弹框
      isdialogVisible: false,
      urlShow: '',
      // 单页数据数量
      pageSize: 20,
      // 数据总数
      countSum: null,
      currentPage: 1,
      //弹框
      dialogVisible: false,
      dialogLookVisible: false,
      rowid: null,
      widthCSH: '1200px'
    }
  },
  created()
  {
    this.getList()
  },
  methods: {
    //获取数据
    getList()
    {
      let type = this.form.type
      let content = this.form.content
      let startTime = this.form.starttime.valueOf() / 1000
      let endTime = this.form.endtime.valueOf() / 1000
      let iscomments = this.form.iscomments
      let count = this.form.count
      let currentPage = this.currentPage
      let exp = ''
      for (let e in this.form)
      {
        let item = this.form[e]
        if (item && e === 'type')
          exp += `type = ${type} and `
        if (item && e === 'content')
          exp += `content like '%${content}%' and `
        if (item && e === 'starttime' && item.valueOf() / 1000 !== 0)
          exp += `addtime > ${startTime} and addtime < ${endTime} and `
        if (item && e === 'iscomments')
          exp += `iscomments = ${iscomments} and `
      }
      exp = exp ? `${exp}id != 0` : 'id>0'
      let paras = {cmd: 'query', _major: 11, _minor: 63, _exp: exp, init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'addtime DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.tableData = []
        ret[0].data.forEach((item, index) =>
        {
          if (item.user !== localStorage.getItem('username'))
          {
            this.tableData.push({
              id: item.id,
              index: index + 1,
              content: item.content,
              thumb: item.thumb ? item.thumb : 'static/images/moren.jpg',
              addtime: item.addtime,
              user: item.user,
              type: item.type,
              iscomments: item.iscomments
            })
          }
        })
        this.countSum = this.tableData.length
      })
    },
    //发布问题
    release()
    {
      this.dialogVisible = true
    },
    //关闭弹框
    cancle()
    {
      this.dialogVisible = false
      this.getList()
    },
    //查看附件
    look(str)
    {
      this.urlShow = str
      this.isdialogVisible = true
    },
    //点击查看
    lookrelease(row)
    {
      this.rowid = row.id
      this.dialogLookVisible = true
    },
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      for (let key in this.form)
      {
        if (key === 'type') continue
        if (key === 'count') continue
        this.form[key] = ''
      }
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/zxxx/FL/LegalOther.vue